import { render, staticRenderFns } from "./JopInfo.vue?vue&type=template&id=6bf0119f&"
import script from "./JopInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./JopInfo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./JopInfo.vue?vue&type=style&index=0&id=6bf0119f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports